var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankunclaimed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 6,
    fill: "#D4F5DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 38.5H29.75C36 38.5 38.5 36 38.5 29.75V22.25C38.5 16 36 13.5 29.75 13.5H22.25C16 13.5 13.5 16 13.5 22.25V29.75C13.5 36 16 38.5 22.25 38.5Z",
    stroke: "#28A745",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9 30.25L30.075 22.075",
    stroke: "#28A745",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4125 23.9625C23.2615 23.9625 23.95 23.274 23.95 22.425C23.95 21.576 23.2615 20.8875 22.4125 20.8875C21.5635 20.8875 20.875 21.576 20.875 22.425C20.875 23.274 21.5635 23.9625 22.4125 23.9625Z",
    stroke: "#28A745",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2125 31.1125C31.0615 31.1125 31.75 30.424 31.75 29.575C31.75 28.726 31.0615 28.0375 30.2125 28.0375C29.3635 28.0375 28.675 28.726 28.675 29.575C28.675 30.424 29.3635 31.1125 30.2125 31.1125Z",
    stroke: "#28A745",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankunclaimed);
export default __webpack_public_path__ + "static/media/bankunclaimed.b7a17f2f892922ac20cd0224c6fa9c1c.svg";
export { ForwardRef as ReactComponent };